/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
  // Select the node that will be observed for mutations
  const targetNode = document.body;
  
  // Create a new instance of the MutationObserver
  const observer = new MutationObserver(function(mutationsList, observer) {
    // Check each mutation that occurred
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Loop through added nodes to check for the loyalty_callout_container
        for (let addedNode of mutation.addedNodes) {
          if (addedNode.id === 'loyalty_callout_container') {
            // Add onclick attribute to the loyalty_callout_container
            addedNode.setAttribute('onclick', 'launchLoyalty(); loyaltyLauncher.blur()');
          }
        }
      }
    }
  });
  
  // Start observing the target node for mutations
  observer.observe(targetNode, { childList: true, subtree: true });

*/




function fetchNote() {
  
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
     
    if(cart.attributes['skinAnalysis-userInput']){
     if (typeof parseQueryStringToUserInput === "function") {
       document.getElementById("chooseVaSetting").style.display = "none";
       document.getElementById("productAttributes").style.display = "block";
       document.getElementById("main").style.display = "block";
      parseQueryStringToUserInput(cart.attributes['skinAnalysis-userInput']);
      setTimeout(() => {
      document.getElementById("redOne").style.display = "block";
      }, 2000);
     } 
    } else {
      document.getElementById("redOne").style.display = "block";
    }

    if (typeof routineFinder === "function") {
    routineFinder();
    }
   
    totalCart = cart.total_price;
    
    cart.items.forEach(item => {
      if (item.gift_card === true) {
        totalCart -= item.final_line_price; // Or use item.line_price based on your configuration
      }
    });
    
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
  }); 
  console.log("Fetch completed");
};




async function addAttributes(attributesObject) {
  
    return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        attributes: attributesObject 
    })
    
  })
  .then(response => response.json())
  .then(cart => {
      console.log(cart);
  })
}

async function addAttribute(attribute, value) {
     
    var attributePair = {};
    attributePair[attribute] = value;
  
    return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        attributes: attributePair 
    })
    
  })
  .then(response => response.json())
  .then(cart => {
      //console.log(cart);
      totalCart = cart.total_price;
    
      cart.items.forEach(item => {
        if (item.gift_card === true) {
          totalCart -= item.final_line_price; // Or use item.line_price based on your configuration
        }
      });
      
      if(attribute == "skinAnalysis-userInput"){
        document.getElementById("main").style.display = "block";
        const body = document.body;
        if(body.classList.contains("visibleWidgets-SA")){
        callAnalysis(); 
        };
        const currentUrl = window.location.href;
        if(!currentUrl.includes('collections')){
        document.getElementById('loader-wrapper').style.display = "none";
        document.getElementById('widget-button-div').style.display = "block";
        document.getElementById('loader-wrapper-vSA').style.display = "none";
        document.getElementById('skinAnalysisModal-VA').style.display = "none"; 
        } else {
        
        setUpMatchBadges();
        showRecommendations();
        document.getElementById('attributeModal').style.display = "none";
        }
        
      }
       document.getElementById('loader-wrapper').style.display = "none";  
     return cart;   
  })
 

}

async function getAttribute(attribute) {
    try {
        let response = await fetch('/cart/update.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        let cart = await response.json();
        return cart.attributes[attribute];
    } catch (error) {
        console.error('Failed to fetch attribute:', error);
    }
}


// Function to add items based on the provided variant array
async function addItems(variantArray) {
  var checkButton = document.getElementById('checkoutButton');
  checkButton.disabled = true;
  checkButton.style.backgroundColor = "lightgray";
  
    for (const variant of variantArray) {
        const result = await fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(variant)
        });

    }
  
  const newDocument = await document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
  }));
  openCartDrawer();
  checkButton.disabled = false;
  checkButton.style.backgroundColor = "#5b6f78";
  
}

async function addItem(variantId, properties) {
  //console.log("addItem: ", variantId);
  initiateAddItem();
 /* let variantID; // Declare variantID in the outer scope

    if (properties) {
        variantID = { id: variantId, quantity: 1, properties: properties }; // Constructing the object here
    } else {
        variantID = { id: variantId, quantity: 1 }; // Constructing the object here
    }*/
    const variantID = {
    id: variantId,
    quantity: 1,
    properties: properties || {} // Use an empty object if properties are not provided
  };

  const result = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(variantID) // Using the constructed object
  });

  if (result.ok) {
    console.log(result);
     
    // Assuming cart:refresh is a custom event for your cart logic
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    result.json().then(function (content){
     
      addItemEnd(); //cart-add-item-popup.liquid
      
     if(typeof checkFreebie === "function"){
           checkFreebie(content);
    }
    })
    //openCartDrawer(); // Ensure this function is defined elsewhere
  } else {
    console.error('Failed to add item to cart');
  }
  /*const event = new CustomEvent('product:added_klaviyo', {
          detail: {
            hideAddToCart: true,
            product: variantId
          }
        });
  document.dispatchEvent(event);*/
}


function openCartDrawer() {
  //console.log('was calles');
    //window.scrollBy(0, 30);
    // Find the cart link element by data-drawer-id attribute
    var cartLink = document.querySelector('[data-drawer-id="sidebar-cart"]');
  
  
    if (cartLink) {
        cartLink.click();
    } 
}
function closeCartDrawer() {
  // Drawer-Element, damit wir prüfen können, ob es geöffnet ist
  const cartDrawer  = document.querySelector('#sidebar-cart');

  // Close-Button, der *gleichzeitig* beide Attribute besitzt
  const closeButton = document.querySelector(
    '[data-drawer-id="sidebar-cart"][data-action="close-drawer"]'
  );

  // Nur klicken, wenn Drawer offen und der Button vorhanden ist
  if (closeButton && cartDrawer?.getAttribute('aria-hidden') === 'false') {
    closeButton.click();
  }
}

document.addEventListener('product:added', function(event) {
    //console.log('Produt added:', event.detail);
    //prepareSamples(); // Your custom function to handle cart updates
    //adjustSample();
});
//setTimeout(()=>{prepareSamples();}, 1000);
document.addEventListener('cart:loading:end', function(event) {
    //console.log('Cart loading end:', event);
    //prepareSamples(); // Your custom function to handle cart updates
    updateTotalCart();
    
});


async function updateTotalCart() {
  
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    var old_cart = totalCart;
    totalCart = cart.total_price;
    
    cart.items.forEach(item => {
      if (item.gift_card === true) {
        totalCart -= item.final_line_price; // Or use item.line_price based on your configuration
      }
    });
    console.log(totalCart);
    if(totalCart != old_cart){
     adjustSample();
     
    }
    
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
  }); 
  
  
};


function clickMatchingHandle(element) {
  // get the handle from the triggering element
  const handle = element.dataset.handle;
  if (!handle) return console.warn("No data-handle on element:", element);

  // find the container
  const container = document.getElementById('sample-main-container');
  if (!container) return console.warn("Container #cs-container not found");

  // query any descendant with the same data-handle
  const target = container.querySelector(`[data-handle="${handle}"]`);

  // click it if found
  if (target) {
    if(!target.classList.contains("selected")){
        target.click();
    }
    openCartDrawer();
    const cartSamples = document.querySelector('#next-freebie-mount');
    cartSamples.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  } else {
    console.warn(`No matching element found with data-handle="${handle}"`);
  }
  
}

function toggleMatchingHandle(element) {
  // get the handle from the triggering element
  element.remove();
 
  const handle = element.dataset.handle;
  
  if (!handle) return console.warn("No data-handle on element:", element);

  // find the container
  const container = document.getElementById('sample-main-container');
  if (!container) return console.warn("Container #cs-container not found");

  // query any descendant with the same data-handle
  const target = container.querySelector(`[data-handle="${handle}"]`);

  // click it if found
  if (target) {
  
     target.click();
    
    openCartDrawer();
  } else {
    console.warn(`No matching element found with data-handle="${handle}"`);
  }
  
}
//three items scroll to anchor - use with <div class="item {{ section.id }}" data-scroll-target="#mein-anchor">
document.addEventListener("click", function (e) {
  const item = e.target.closest(".item[data-scroll-target]");
  if (!item) return;

  const targetSelector = item.getAttribute("data-scroll-target");
  const target = document.querySelector(targetSelector);
  if (!target) return;

  // Header-Höhe aus CSS-Variable holen
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
  );

  // Ziel-Position berechnen
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const scrollTo = targetPosition - headerHeight;

  // Smooth scroll
  window.scrollTo({
    top: scrollTo,
    behavior: "smooth"
  });
});


function preserveScrollDuringUpdate(containerSelector, updateFn) {
  const container = document.querySelector(containerSelector);
  if (!container) {
    updateFn();
    return;
  }

  const scrollTop = container.scrollTop;
  updateFn();

  requestAnimationFrame(() => {
    const newContainer = document.querySelector(containerSelector);
    if (newContainer) newContainer.scrollTop = scrollTop;
  });
}